import { TextBoxStyle as Style } from "common/components/text-box-types";
import type { RuntimeTheme } from "../../../lib/theme/core-themes/runtime-theme";
import { css, styled } from "../../../styled-components";

export function lineHeightForStyle(style: Style, theme: RuntimeTheme) {
    switch (style) {
        case Style.BodySmall:
            return theme.fontStyles.Body5Height;
        case Style.Body:
            return theme.fontStyles.Body4Height;
        case Style.BodyLarge:
            return theme.fontStyles.Body3Height;
        case Style.Footnote:
            return theme.fontStyles.Body6Height;
        case Style.H1:
            return theme.fontStyles.AccentHeader1Height;
        case Style.H2:
            return theme.fontStyles.AccentHeader2Height;
        case Style.H3:
            return theme.fontStyles.AccentHeader3Height;
        case Style.H4:
            return theme.fontStyles.AccentHeader4Height;
    }
}

const bodySmall = css`
    ${p => p.theme.fontStyles.Body5}
`;

const body = css`
    ${p => p.theme.fontStyles.Body4}
`;

const bodyLarge = css`
    ${p => p.theme.fontStyles.Body3}
`;

const footnote = css`
    ${p => p.theme.fontStyles.Body6}

    color: ${p => p.theme.fgColorMedium};
`;

const h1 = css`
    ${p => p.theme.fontStyles.AccentHeader1}
`;

const h2 = css`
    ${p => p.theme.fontStyles.AccentHeader2}
`;

const h3 = css`
    ${p => p.theme.fontStyles.AccentHeader3}
`;

const h4 = css`
    ${p => p.theme.fontStyles.AccentHeader4}
`;

function themeForStyle(style: Style) {
    switch (style) {
        case Style.BodySmall:
            return bodySmall;
        case Style.Body:
            return body;
        case Style.BodyLarge:
            return bodyLarge;
        case Style.Footnote:
            return footnote;
        case Style.H1:
            return h1;
        case Style.H2:
            return h2;
        case Style.H3:
            return h3;
        case Style.H4:
            return h4;
    }
}

interface Props {
    readonly textStyle: Style;
}
export const TextBoxStyle = styled.div<Props>`
    padding: ${p => p.theme.componentSmallInnerVerticalPadding}px ${p => p.theme.pageMarginMedium}px;
    color: ${p => p.theme.fgColorDark};

    ${p => themeForStyle(p.textStyle)}

    &.caps {
        text-transform: uppercase;
    }

    &:not(.wrap) div {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    &.left {
        text-align: left;
    }

    &.justify {
        text-align: justify;
    }

    &.center {
        text-align: center;
    }

    &.right {
        text-align: right;
    }
`;
